const axios = require('axios')
const { v4: uuidv4 } = require('uuid');

function getHeaders () {
  return { 
    'Content-Type': 'application/json',
  }
}
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // timeout: 1000,
  headers: getHeaders()
})
function getLanguage () {
  return localStorage?.getItem('language')
    ? localStorage?.getItem('language')
    : 'en'
}
instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  config = {
    ...config,
    headers: { ...config.headers, language: getLanguage(), 'Idempotency-Key': uuidv4() }
  }
  if (!token) {
    return config
  }
  document.getElementById('loader').classList.remove('hidden')
  config = {
    ...config,
    headers: { ...config.headers, Authorization: `Bearer ${token}` }
  }
  return config
})

instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    // console.log('response:',response)
    document.getElementById('loader').classList.add('hidden')
    return response
  },
  function (error) {
    document.getElementById('loader').classList.add('hidden')
    const { status } = error.response
    if (status === 401 || status === 403) {
      localStorage.removeItem('token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('uniqueId')
      window.location.reload()
    }
    return Promise.reject(error)
  }
)

function apiGet (url, params = {}, signal = null) {
  return instance.get(url, { params, signal })
}

function apiPost (url, body, signal = null) {
  return instance.post(url, body, signal )
}

function apiPut (url, body, signal = null) {
  return instance.put(url, body, signal )
}

function apiDelete (url, signal = null) {
  return instance.delete(url, signal )
}

export { apiDelete, apiGet, apiPost, apiPut, getHeaders };

